import { Blocks, CtaBand, CtaRow, Crumbs, FaqList, Related, Rich, type Block, type QA } from '@/site/content'
import { breadcrumbList, type Crumb, type PageMeta } from '@/site/meta'
import { SiteShell } from '@/site/SiteShell'

/* Prices are not set yet: every sum is a [TODO] the owner fills in, and the
 * prerender keeps this page out of search until none is left. The rows are
 * what a plan actually limits (billing: package, overage or block, caps). */

const TRAIL: Crumb[] = [{ name: 'Головна', path: '/' }, { name: 'Ціни', path: '/tsiny' }]

export const meta: PageMeta = {
  title: 'Ціни на AI-агента для дзвінків | Anytel',
  description:
    'Тарифи Anytel: абонплата за кабінет і хвилини розмов AI-агента. Що входить у кожен тариф, як рахуються хвилини і що дає пробний період.',
  schema: [breadcrumbList(TRAIL)],
}

const PLANS = ['[TODO: назва тарифу 1]', '[TODO: назва тарифу 2]', '[TODO: назва тарифу 3]']

/** One row per thing a plan limits; a cell is either text or a placeholder. */
const ROWS: { label: string; cells: string[] }[] = [
  { label: 'Абонплата на місяць', cells: ['[TODO: сума, грн]', '[TODO: сума, грн]', '[TODO: сума, грн]'] },
  { label: 'Хвилини AI-агента в пакеті', cells: ['[TODO: хв]', '[TODO: хв]', '[TODO: хв]'] },
  { label: 'Хвилина понад пакет', cells: ['[TODO: грн/хв або «не можна»]', '[TODO: грн/хв]', '[TODO: грн/хв]'] },
  { label: 'Номери та SIP-адреси', cells: ['[TODO: кількість]', '[TODO: кількість]', '[TODO: кількість]'] },
  { label: 'Користувачі кабінету', cells: ['[TODO: кількість]', '[TODO: кількість]', '[TODO: кількість]'] },
  { label: 'Одночасні дзвінки', cells: ['[TODO: кількість]', '[TODO: кількість]', '[TODO: кількість]'] },
  { label: 'Зберігання записів', cells: ['[TODO: днів]', '[TODO: днів]', '[TODO: днів]'] },
  { label: 'Транскрипція розмов', cells: ['[TODO: грн/хв]', '[TODO: грн/хв]', '[TODO: грн/хв]'] },
  { label: 'Переадресація на зовнішні номери', cells: ['[TODO: грн/хв]', '[TODO: грн/хв]', '[TODO: грн/хв]'] },
  { label: 'Чат-боти в месенджерах', cells: ['[TODO: так/ні]', '[TODO: так/ні]', '[TODO: так/ні]'] },
]

const IN_EVERY_PLAN = [
  'AI-агент українською з базою знань',
  'Конструктор сценаріїв і голосове меню',
  'Календарі й запис клієнтів',
  'Записи розмов у кабінеті',
  'Заявки, сповіщення в Telegram і на пошту',
  'Вебхуки й REST API',
  'Тестові дзвінки з браузера',
]

const TRIAL: Block[] = [
  {
    list: [
      'Тривалість: [TODO: 14 днів і/або N хвилин].',
      'Без банківської картки.',
      'Агент, сценарії, календарі й записи розмов, як у тарифі [TODO: на якому тарифі працює пробний період].',
      'Тестові дзвінки з браузера, ще до підключення номера.',
      'Допомога з першим сценарієм, якщо хочете налаштувати разом.',
    ],
  },
  'Після пробного періоду: [TODO: що відбувається: автоматичний перехід на тариф чи пауза до оплати].',
]

const MINUTES: Block[] = [
  'Хвилини AI-агента рахуються за фактичною тривалістю розмови з ним. У тарифі є пакет хвилин на місяць. Що буде, коли пакет закінчився, залежить від тарифу: або хвилини понад пакет оплачуються окремо, або агент перестає приймати нові розмови до наступного місяця, а дзвінки йдуть далі за сценарієм.',
  'Переадресація на зовнішні номери і транскрипція оплачуються з першої хвилини, поза пакетом: це пряма вартість оператора зв’язку і розпізнавання мовлення.',
  'Коли використано 80% і 100% пакета, ви отримуєте сповіщення. Залишок видно в кабінеті в розділі «Тариф і рахунки».',
  'Тестові дзвінки з браузера не тарифікуються.',
]

const FAQ: QA[] = [
  {
    q: 'Що, якщо пакет хвилин закінчиться посеред місяця?',
    a: 'Ви отримаєте сповіщення на 80% і 100% пакета. Далі все залежить від тарифу: або хвилини оплачуються понад пакет, або агент не приймає нових розмов до кінця місяця. Тариф можна змінити, якщо хвилин регулярно бракує.',
  },
  {
    q: 'Чи тарифікуються тестові дзвінки?',
    a: 'Ні. Дзвінки з браузера, якими ви перевіряєте агента і сценарій, безкоштовні.',
  },
  {
    q: 'Як оплатити?',
    a: 'Рахунок виставляється раз на місяць, його видно в кабінеті й можна роздрукувати. Способи оплати: [TODO: способи оплати].',
  },
  {
    q: 'Чи є знижки для мереж і філій?',
    a: '[TODO: умови для кількох філій або великих обсягів]. Для нестандартних обсягів напишіть нам, і ми порахуємо індивідуально.',
  },
]

export default function PricingPage() {
  return (
    <SiteShell>
      <main id="main" className="lp-page">
        <div className="lp-wrap">
          <Crumbs items={TRAIL} />
          <header className="lp-page-head">
            <p className="lp-eyebrow">Ціни</p>
            <h1>Ціни на Anytel</h1>
            <p className="lp-page-lead">
              Оплата складається з двох частин: абонплати за кабінет і хвилин розмов AI-агента. Нижче тарифи, що
              входить у кожен і як рахуються хвилини.
            </p>
            <CtaRow />
          </header>
        </div>

        <section className="lp-wrap lp-pricing-table" aria-label="Тарифи">
          <div className="lp-table-scroll">
            <table>
              <thead>
                <tr>
                  <th scope="col"><span className="lp-sr">Що входить</span></th>
                  {PLANS.map((p) => <th key={p} scope="col"><Rich text={p} /></th>)}
                </tr>
              </thead>
              <tbody>
                {ROWS.map((r) => (
                  <tr key={r.label}>
                    <th scope="row">{r.label}</th>
                    {r.cells.map((c, i) => <td key={i}><Rich text={c} /></td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="lp-pricing-common">
            <h2>У кожному тарифі</h2>
            <ul>{IN_EVERY_PLAN.map((x) => <li key={x}>{x}</li>)}</ul>
          </div>
        </section>

        <div className="lp-wrap lp-prose">
          <section className="lp-prose-section">
            <h2>Що входить у пробний період</h2>
            <Blocks blocks={TRIAL} />
          </section>
          <section className="lp-prose-section">
            <h2>Як рахуються хвилини</h2>
            <Blocks blocks={MINUTES} />
          </section>
        </div>

        <section className="lp-wrap lp-page-faq">
          <h2>Питання про оплату</h2>
          <FaqList items={FAQ} />
        </section>

        <CtaBand title="Спробуйте до того, як обирати тариф" />
        <Related paths={['/faq', '/blog/ai-agent-chy-administrator', '/funktsii']} />
      </main>
    </SiteShell>
  )
}
